import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OpportunityContact from "@/services/opportunity/opportunity-contact";

/**
 * Composable for deleting an opportunity contact
 */
export function useDeleteOpportunityContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await OpportunityContact.deleteOpportunityContact(id);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete opportunity contact");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opportunityContacts"] });
      queryClient.invalidateQueries({ queryKey: ["opportunities"] });
    },
  });
}
